import { apiBase } from './apiBase'
import { getQueryString } from 'lib/utils'

export const customersApi = apiBase.injectEndpoints({
	endpoints: (builder) => ({
		getCustomers: builder.query({
			query: (criteria) => `customers?${getQueryString(criteria)}`,
		}),
	}),
})

export const {
	useGetCustomersQuery,
	useLazyGetCustomersQuery,
} = customersApi